jQuery(document).ready(function ($) {
  var campaignApiKey = mb_theme_envs.campaign_api_key;
  var campaignApiURL = mb_theme_envs.campaign_api_url;
  const phoneCIDsName = "mb-phone-cids";
  const currentPhoneCIDName = "mb-current-phone-cid";
  // OLD Design based header and footer class names
  const oldDesktopPhoneNumberClassName = ".mb-header-call-now";
  const oldMobilePhoneNumberClassName = ".mb-mobile-phone-btn";
  const oldFooterPhoneNumberClassName = ".et_pb_button_0_tb_footer";
  const mbMobileCTA = ".mb-dynamic-mobile-cta";

  // NEW Design based header and footer class names
  const desktopPhoneNumberClassName = ".mb_call_number_btn";
  const mobilePhoneNumberClassName = ".mb_call_now_btn";
  const slideMenuPhoneNumberClassName = ".mb_slide_menu_callbtn";

  const cidParam = getParamFromURL("cid");
  const savedPhoneNumberCIDs = localStorage.getItem(phoneCIDsName);
  const savedCurrentPhoneCID = sessionStorage.getItem(currentPhoneCIDName);

  var mappingArr = [];
  initPhoneLeadTracking();

  function initPhoneLeadTracking() {
    if (cidParam && isValidCID(cidParam)) {
      if (savedPhoneNumberCIDs) {
        var existingMapping = getExistingCIDFromMapping(
          JSON.parse(savedPhoneNumberCIDs),
          cidParam
        )[0];
        if (existingMapping) {
          if (existingMapping.number) {
            setPhoneCIDInSession(existingMapping);
            updatePhoneNumbersInPage(existingMapping);
          }
        } else {
          mappingArr = JSON.parse(savedPhoneNumberCIDs);
          fetchPhoneNumber(cidParam);
        }
      } else {
        mappingArr = [];
        fetchPhoneNumber(cidParam);
      }
    } else if (savedCurrentPhoneCID) {
      var phoneCID = JSON.parse(savedCurrentPhoneCID);

      if (phoneCID && phoneCID.number) {
        updatePhoneNumbersInPage(phoneCID);
      }
    }
  }

  function fetchPhoneNumber(cid) {
    var campaign_apiKey = campaignApiKey;
    var apiurl = campaignApiURL + "?key=" + campaign_apiKey + "&cid=" + cid;
    $.ajax({
      url: apiurl,
      type: "GET",
      success: onFetchPhoneNumberSuccess,
    });
    // No error function since default number will display on load
  }

  function onFetchPhoneNumberSuccess(res) {
    // phone
    var phoneCIDObj = {
      id: cidParam,
      number: res.data.number,
      display_number: res.data.display_number,
    };
    mappingArr.push(phoneCIDObj);
    localStorage.removeItem(phoneCIDsName);
    localStorage.setItem(phoneCIDsName, JSON.stringify(mappingArr));
    setPhoneCIDInSession(phoneCIDObj);
    updatePhoneNumbersInPage(phoneCIDObj);
  }

  function isValidCID(cid) {
    return /^\w{7,10}$/gm.test(cid);
  }

  function setPhoneCIDInSession(phoneCID) {
    sessionStorage.removeItem(currentPhoneCIDName);
    sessionStorage.setItem(currentPhoneCIDName, JSON.stringify(phoneCID));
  }

  function getExistingCIDFromMapping(savedPhoneNumberCIDs, cidParam) {
    // To Support IE 11
    return savedPhoneNumberCIDs.filter(function (e) {
      return e.id.toLowerCase() === cidParam;
    });
  }

  function getParamFromURL(param) {
    const paramLower = param;
    const paramUpper = param.toUpperCase();
    if (!!window.MSInputMethodContext && !!document.documentMode) {
      // IE 11 support
      const params = {};
      window.location.href.replace(
        /[?&]+([^=&]+)=([^&]*)/gi,
        function (_, key, value) {
          return (params[key] = value);
        }
      );

      var cidParam = params[paramLower]
        ? decodeURIComponent(params[paramLower])
        : params[paramUpper]
          ? decodeURIComponent(params[paramUpper])
          : "";

      return cidParam ? cidParam.toLowerCase().replace(/\s/g, "") : "";
    } else {
      const params = new URL(document.location).searchParams;
      // Params are case sensitive
      var cidParam = params.get(paramLower)
        ? decodeURIComponent(params.get(paramLower))
        : params.get(paramUpper)
          ? decodeURIComponent(params.get(paramUpper))
          : "";
      return cidParam ? cidParam.toLowerCase().replace(/\s/g, "") : "";
    }
  }

  function updatePhoneNumbersInPage(phoneCIDObj) {
    var oldDesktopPhoneNumberElements = $(oldDesktopPhoneNumberClassName);
    var oldMobilePhoneNumberElements = $(oldMobilePhoneNumberClassName);
    var mbMobileCTAElements = $(mbMobileCTA);
    var oldFooterPhoneNumberElements = $(oldFooterPhoneNumberClassName);

    // NEW Design based elements
    var desktopPhoneNumberElements = $(desktopPhoneNumberClassName);
    var mobilePhoneNumberElements = $(mobilePhoneNumberClassName);
    var slideMenuPhoneNumberElements = $(slideMenuPhoneNumberClassName);

    oldDesktopPhoneNumberElements.each(function () {
      $(this).text("Call " + phoneCIDObj.display_number);
      $(this).attr("href", "tel:" + phoneCIDObj.number);
    });

    oldMobilePhoneNumberElements.each(function () {
      $(this).attr("href", "tel:" + phoneCIDObj.number);
    });

    oldFooterPhoneNumberElements.each(function () {
      $(this).text("Call " + phoneCIDObj.display_number);
      $(this).attr("href", "tel:" + phoneCIDObj.number);
    });

    mbMobileCTAElements.each(function () {
      $(this).attr("href", "tel:" + phoneCIDObj.number);
    });

    // NEW Design based elements
    desktopPhoneNumberElements.each(function () {
      $(this).text("Call " + phoneCIDObj.display_number);
      $(this).attr("href", "tel:" + phoneCIDObj.number);
    });

    mobilePhoneNumberElements.each(function () {
      $(this).attr("href", "tel:" + phoneCIDObj.number);
    });

    slideMenuPhoneNumberElements.each(function () {
      $(this).attr("href", "tel:" + phoneCIDObj.number);
    });
  }
});
